module.exports = __webpack_public_path__ + "29a0c5c3ee3f5c0eae7ed8c6642a2c57.svg";